import React, { useState } from 'react'

import './styles.scss'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import ModalDelete from 'components/ModalDelete'
import { foldersAPI } from 'api'

const FolderItem = props => {
  const { color, folderId, folders, name, setFolders, toggleFolderModal, totalConversations } = props
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [deleteError, setDeleteError] = useState('')
  const [deleteConfirmation, setDeleteConfirmation] = useState(false)

  const toggleDeleteModal = () => {
    if (isOpenDeleteModal && deleteError) setDeleteError('')
    setIsOpenDeleteModal(prevState => !prevState)
  }

  const handleDeleteFolder = () => {
    if (deleteError) setDeleteError('')

    const data = { folderId }
    if (deleteConfirmation) data.forceDelete = true

    setIsDeleting(true)
    foldersAPI.deleteFolder(data)
      .then(({ data }) => {
        if (data.error) {
          if (data.type === 'list_with_conversations') {
            setDeleteConfirmation(true)
            setDeleteError(lang('dashboard_list-with-conversations-count', { count: data.count }))
          }
        } else {
          const updatedFolders = folders.filter(({ _id }) => _id !== folderId)
          setFolders(updatedFolders)
          toggleDeleteModal()
        }
      })
      .catch(() => setDeleteError(lang('dashboard_error-deleting-folder')))
      .finally(() => setIsDeleting(false))
  }

  return (
    <div className='folder-view-item'>
      <i className='fa fa-folder-o folder-view-item__icon' aria-hidden='true' style={{ color: color || null }} />
      <p className='folder-view-item__name text-ellipsis' title={name}>{name}</p>
      <div className='folder-view-item__info'>
        <div className='folder-view-item__info-item'>
          <label>{lang('dashboard_conversations')}</label>
          <strong>{totalConversations || 0}</strong>
        </div>
      </div>
      <div className='folder-view-item__actions'>
        <button
          className='folder-view-item__action-icon-btn'
          title={lang('dashboard_edit')}
          onClick={() => toggleFolderModal(folderId)}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt={lang('dashboard_edit')} />
          </figure>
        </button>
        <button
          className='folder-view-item__action-icon-btn'
          title={lang('dashboard_delete')}
          onClick={toggleDeleteModal}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt={lang('dashboard_delete')} />
          </figure>
        </button>
      </div>

      {/* Delete modal */}
      <ModalDelete
        isOpen={isOpenDeleteModal}
        toggle={toggleDeleteModal}
        event={handleDeleteFolder}
        header={lang('dashboard_delete-folder')}
        text1={lang('dashboard_delete-folder-confirm')}
        text2={lang('dashboard_action-cannot-reversed')}
        isSubmitting={isDeleting}
        errorMessage={deleteError}
        errorMessageInternationalization={false}
      />
    </div>
  )
}

export default FolderItem
